import React from "react";
import { Button, Dropdown, Menu } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchaseDrDetailsModel } from "./details/purchaseDrDetailsModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { usePurchaseDrModel } from "../purchaseDrModel";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import useGlobalModel from "@/model/globalModel";

export const DataBox = () => {
    const { selectedRowKeys, statistics, exportPurchaseDr, exportStatisticsExport, dataSource } = usePurchaseDrModel();
    const { resetEditCatch } = usePurchaseDrDetailsModel(() => []);
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { user: { shopCode } } = useGlobalModel();

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (dataSource.find((item: any) => item.id == selectedRowKeys[0])?.shopCode !== shopCode) {
            globalPrompt("message", { text: "请选择本站点下的工单进行编辑，可以点击单号进入查看哦！", type: "warning" });
            return;
        }
        let purchaseDrEditKey = "16-1-2";
        let isFindNav = findNav(purchaseDrEditKey);
        if (!isFindNav) {
            addNav(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
            resetEditCatch()
        } else {
            globalPrompt("modal", {
                title: "调入单跳转详情",
                type: "warning",
                text: "您还有调入单单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(purchaseDrEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
                    resetEditCatch()
                }
            })
        }
    }

    const desc: IDescription[] = [
        {
            label: "调入数量",
            value: statistics?.totalNum,
            color: DescriptionColorEnum.green
        },
        {
            label: "应付金额",
            value: `￥${statistics.totalAmount}`,
            color: DescriptionColorEnum.red
        }
    ]
    // const printMenu = (
    //     <Menu>
    //         <Menu.Item key="1" onClick={() => exportPurchaseDr()}>
    //             列表导出
    //         </Menu.Item>
    //         <Menu.Item key="0" onClick={() => exportStatisticsExport()}>
    //             明细导出
    //         </Menu.Item>
    //     </Menu>
    // );
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_DR_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("16-1-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_DR_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_DR_EX}>
            {/* <Dropdown overlay={printMenu} trigger={['hover']}> */}
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportPurchaseDr()}
            >导出</Button>
            {/* </Dropdown> */}
        </YhAuth>
    </>;

    return (
        // <YhBox title="调入单列表" descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}